import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";

// This is a client-side route component for React Router instead of Next.js API route
export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
      const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";
      const supabase = createClient(supabaseUrl, supabaseKey, {
        auth: {
          persistSession: true,
          storageKey: "sb-auth-token",
        },
      });

      try {
        if (window.location.hash) {
          const {
            data: { session },
            error,
          } = await supabase.auth.getSession();

          if (error) {
            navigate("/login");
            return;
          }

          if (session) {
            document.cookie = `sb-access-token=${
              session.access_token
            }; path=/; max-age=${60 * 60 * 24 * 7}`;
            document.cookie = `sb-refresh-token=${
              session.refresh_token
            }; path=/; max-age=${60 * 60 * 24 * 7}`;
            navigate("/dashboard");
            return;
          }
        }

        navigate("/login");
      } catch (error) {
        navigate("/login");
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
    </div>
  );
}
